import api from './api';

// NOTE (2026-09): the System A embedding/query endpoints (embed, embedding-status,
// query, stats) were retired backend-side. Only Phase 2 patent acquisition remains.

export interface AcquisitionResponse {
  status: string;
  sub_project_id: string;
  total_patents: number;
  message: string;
}

export interface AcquisitionStatusResponse {
  status: string;
  data?: {
    acquired_count: number;
    failed_count: number;
    total_patents: number;
    progress_percent: number;
  };
  error?: string;
}

class SemanticSearchService {
  private baseUrl = '/api/sub-projects';

  async acquirePatents(
    subProjectId: string,
    patentIds: string[]
  ): Promise<AcquisitionResponse> {
    const response = await api.post(
      `${this.baseUrl}/${subProjectId}/semantic-search/acquire`,
      { patent_ids: patentIds }
    );
    return response.data;
  }

  async getAcquisitionStatus(
    subProjectId: string
  ): Promise<AcquisitionStatusResponse> {
    const response = await api.get(
      `${this.baseUrl}/${subProjectId}/semantic-search/acquisition-status`
    );
    return response.data;
  }
}

export const semanticSearchService = new SemanticSearchService();
